/**
 * PublicCategoriesService
 * Anonymous-capable public category list. Cross-ministry categories
 * (<c>MinistryID = null</c>) are always returned.
 * Route: api/public/categories
 */
import { BaseService } from '../base/BaseService';
export class PublicCategoriesService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PublicCategoriesService.DEFAULT_SERVICE_PATH,
            basePath: PublicCategoriesService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async list(ministryId) {
        const response = await this.listRaw(ministryId);
        return response.data ?? [];
    }
    listRaw(ministryId) {
        const suffix = ministryId != null ? `?ministryId=${ministryId}` : '';
        return this.http.get(this.buildUrl(suffix));
    }
}
PublicCategoriesService.DEFAULT_SERVICE_PATH = 'resources';
PublicCategoriesService.BASE_PATH = 'api/public/categories';
//# sourceMappingURL=PublicCategoriesService.js.map